class viewUtils {

    static getToken() {
        return localStorage.getItem("admin-token") || ''
    }

    static logout() {
        localStorage.removeItem("admin-token");
        this.goToLoginPage()
    }

    static goToAdminRootPage() {
        window.location.replace(`${window.location.origin}/system_manage`)
    }

    static goToLoginPage() {
        window.location.replace(`${window.location.origin}/login`)
    }

    static prettyWithLang(data: any, lang?: string, key?: string) {
        if(!!key) {
            if(lang === 'en') {
                return (data?.en || {})[key] || (data?.zh || {})[key] || (data?.en || {})[key]
            } else if(lang === 'ja') {
                return (data?.ja || {})[key] || (data?.zh || {})[key] || (data?.en || {})[key]
            } else {
                return (data?.zh || {})[key] || (data?.en || {})[key] || (data?.ja || {})[key]
            }
        } else {
            if(lang === 'en') {
                return data?.en || data?.zh || data?.en
            } else if(lang === 'ja') {
                return data?.ja || data?.zh || data?.en
            } else {
                return data?.zh || data?.en || data?.ja
            }
        }
    }

    static showCategoryName = (category: any, lang: string = "zh", split: string = "-") => {
        if(
            category?.menu?.is_show &&
            !(['news'].includes(category?.menu?.page_config?.type))
        ) {
            return `${viewUtils.prettyWithLang(category?.menu?.name, lang)}${split}${viewUtils.prettyWithLang(category?.name, lang)}`
        } else {
            return viewUtils.prettyWithLang(category?.name, lang)
        }
    }

}

export default viewUtils;
